import { authHeader, proxy } from '@helpers';

export const clientService = {
    create,
    getAll,
    getById,
    update,
    delete: deleteClient,
};

async function create(client) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(client),
    };

    const response = await fetch(`${proxy}/clients`, requestOptions);
    return handleResponse(response);
}

async function getAll(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    const response = await fetch(`${proxy}/clients${userId ? `/users/${userId}` : ''}`, requestOptions);
    return handleResponse(response);
}

async function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    };

    const response = await fetch(`${proxy}/clients/${id}`, requestOptions);
    return handleResponse(response);
}

async function update(client) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(client),
    };

    const response = await fetch(`${proxy}/clients`, requestOptions);
    return handleResponse(response);
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function deleteClient(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify({ id }),
    };

    const response = await fetch(`${proxy}/clients/${id}`, requestOptions);
    return handleResponse(response);
}

async function handleResponse(response) {
    return await response.text().then((text) => {
        let data = text;
        try {
            data = text && JSON.parse(text);
        } catch (error) {
            console.error('cannot convert String to JSON', error);
        }
        if (!response.ok) {
            if (response.status == 401) {
                // auto logout if 401 response returned from api
                //logout();
                //location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
